<template>
  <div id="login-bg" :style="{background: background, backgroundSize: 'cover', height: '100vh', width: '100vw', position: 'fixed'}">
    <!--
    <div class="particle-outer">
      <particles :config="particles" :styles="{ height: '100%', width: '100%' }"></particles>
    </div>
    -->
    <div id="login-content">
      <div id="login-form">
        <!--
          <div class="right-sided">
            <particles
              :config="particles"
            ></particles>
          </div>
        -->
        <form class="right-sided">
          <img class="company-logo" src="/static/img/logo.png" alt="company-logo"/>
          <div v-if="errorMessage" class="alert alert-danger error-message">
            {{ errorMessage }}
          </div>
          <password-reset v-if="passwordReset" />
          <div v-else>
            <div class="form-group">
              <label for="username" class="form-label">Username</label>
              <input @keyup.enter="login" type="text" class="form-control" id="username" v-model="username" placeholder="Username"/>
            </div>
            <div class="form-group">
              <label for="password" class="form-label">Password</label>
              <input @keyup.enter="login" type="password" class="form-control" id="password" v-model="password" placeholder="Password"/>
              <a @click.stop="resetPassword">Forgotten your password?</a>
            </div>
  <!--          <div id="cap"></div>-->
            <button :class="[ isBot ? 'disabled' : '', 'btn btn-primary']" @click="login">Let's go</button>
          </div>
          <p class="text-center mt10">Powered by MoveAssist</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import particlesJS from 'particles.js'
  import Particles from '../modules/helpers/Particles.vue'
  import particleConfig from '../../static/js/particles-config.json'
  import event from '../event'
  import config from '../config'
  import API from '../api/endpoints'
  import PasswordReset from './PasswordReset'
  export default {
    name: 'Login',
    components: {
      Particles,
      PasswordReset
    },
    data (router) {
      return {
        section: 'Login',
        loading: '',
        username: '',
        password: '',
        response: '',
        bg: 1,
        particles: particleConfig,
        loginMessages: 0,
        widget: null,
        isBot: false,
        captchaSitekey: config.captchaSitekey,
        errorMessage: null,
        passwordReset: false
      }
    },
    computed: {
      background () {
        return `url(/static/img/bg${this.bg}.jpg)`
      },
      user () {
        return this.$store.getters['authentication/user']
      },
      nextPage () {
        return this.$store.getters['authentication/landingPage']
      }
    },
    watch: {
      username () { this.clearErrorMessage() },
      password () { this.clearErrorMessage() },
      '$route' (newVal) {
        this.passwordReset = newVal.query['password-reset']
      }
    },
    methods: {
      clearErrorMessage () { this.errorMessage = null },
      emitEvent (e) {
        /*
        * The login Message appears to be firing twice;
        * temporary 'fix' put in place to stop this
        * using 'debounce'
        */
        let shouldBeEqual = this.loginMessages
        setTimeout(() => {
          if (shouldBeEqual == this.loginMessages) {
            event.$emit('toast', e)
          }
        }, 250)
      },
      doCaptcha (r) {
        this.$http.post(API.GET_CAPTCHA, { response: window.grecaptcha.getResponse(this.widget) })
        .then(({data}) => {
          if (data.success) {
            this.isBot = false
          }
        }).catch(err => console.log(err))
      },
      login (e) {
        this.clearErrorMessage()
        e.preventDefault()
        if (this.isBot) {
          this.doWarning()
        } else {
          this.doLogin()
        }
      },
      doLogin () {
        console.log('login')
        event.$emit('loading-on', { title: 'Authenticating' })
        this.$store.dispatch('authentication/login', { username: this.username, password: this.password })
          .then((res) => {
            this.$store.dispatch('authorization/addTokenFromLogin', res)
            .then(done => {
              this.emitEvent({ type: 'success', message: 'Login successful' })
              let toName
              if (this.nextPage) {
                switch (this.nextPage) {
                  case 'NEW_QUOTE':
                    toName = 'Add a new Quote'
                    break
                  case 'DASHBOARD':
                    toName = 'Dashboard'
                    break
                  case 'ALL_QUOTES':
                    toName = 'Quotes - all'
                    break
                  default:
                    toName = 'Add a new Quote'
                    break
                }
              } else {
                toName = 'Add a new Quote'
              }
              this.$router.push({ name: toName, query: { fromLogin: 'true' } })
            })
          }).catch((err) => {
            console.log('err', err)
            if (err && err.status === 401) {
              this.errorMessage = err.body
            } else {
              this.errorMessage = 'Error occurred. Please contact system administrator.'
            }
          }).then(() => {
            event.$emit('loading-off')
            this.loginMessages += 1
          })
      },
      resetCaptcha () {
        this.isBot = true
      },
      doWarning () {
        event.$emit('toast', { type: 'warning', message: 'Please confirm you are not a robot before proceeding' })
      },
      doSetup () {
        let self = this
        // let interval = setInterval(() => {
        //   if (window.grecaptcha) {
        //     self.widget = window.grecaptcha.render('cap', {
        //       sitekey: self.captchaSitekey,
        //       theme: 'light',
        //       callback: self.doCaptcha,
        //       'expired-callback': self.resetCaptcha
        //     })
        //     clearInterval(interval)
        //   }
        // }, 250)
      },
      resetPassword (e) {
        this.clearErrorMessage()
        this.$router.push({ name: 'Login', query: { 'password-reset': '1' } })
      }
    },
    mounted () {
      this.doSetup()
      this.passwordReset = this.$route.query['password-reset']
    },
    created () {
      this.bg = Math.ceil(Math.random() * 4)
    }
  }
</script>

<style scoped>
  a {
    cursor: pointer;
  }

  #particles {
    width: 100%;
    height: 100%;
  }
  #login-content {
    display: flex;
    align-items: center;
    height:100%;
    width:100%;
    position: absolute;
    top:0;
    left:0;
    background: rgba(0,0,0,0.5);
  }
  #login-form form {
    background-color: #ffffff;
    border-radius: 5px;
    padding: 20px;
    min-width: 350px;
  }
  .company-logo {
    display: block;
    margin: auto;
    max-width: 50%;
  }
  button {
    display: block;
    margin: auto;
  }
  a {
    font-size:10px;
  }
  .watermark {
    margin:auto;
    display: block;
    padding-top: 5px;
    max-width: 75%;
  }
  input {
    background-color: #f3f2ee;
  }
  @media only screen and (max-width: 768px) {
    #login-form {
      margin: auto;
    }
    .right-sided {
      margin-left: 0 !important;
    }
  }
  .right-sided {
    margin-left: 55vw;
  }
  h1 {
    font-size: 32px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .error-message {
    max-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue